import React from 'react';
import { useParams } from 'react-router-dom';
import SmartDoc from './apps/SmartDoc';
import AIContentCreatorApp from './apps/AIContentCreatorApp';
import EmailMentor from './apps/EmailMentor';
import StudySnap from './apps/StudySnap';
import BrandForge from './apps/BrandForge';
import DocuCraft from './apps/DocuCraft';
import FlowBuilder from './apps/FlowBuilder';
import MeetGenie from './apps/MeetGenie';
import MeetMate from './apps/MeetMate';
import PitchCraft from './apps/PitchCraft';
import SkillSage from './apps/SkillSage';
import TrendPulse from './apps/TrendPulse';
import VisionGaurd from './apps/VisionGaurd';
import WikiForge from './apps/WikiForge';
import LeadCollector from './apps/LeadCollector';
import ScriptCraftAI from './apps/ScriptCraft';
import AdGenieSalons from './apps/AdGenieSalons';
import ReplyBotOnboarding from './apps/Replybot/ReplyBotOnboarding';

// import AIContentStudio from './apps/AIContentStudio'; // future apps

const routeMap = {
  'smart-doc': SmartDoc,
  'content-creator': AIContentCreatorApp,
  'email-mentor': EmailMentor,
  'study-snap': StudySnap,
  'brand-forge': BrandForge,
  'pitch-craft': PitchCraft,
  'meet-mate': MeetMate,
  'skill-sage': SkillSage,
  'wiki-forge': WikiForge,
  'trend-pulse': TrendPulse,
  'vision-gaurd': VisionGaurd,
  'docu-craft': DocuCraft,
  'flow-builder': FlowBuilder,
  'meet-genie': MeetGenie,
  'lead-collector': LeadCollector,
  'script-craft': ScriptCraftAI,
  'ad-genie-salon': AdGenieSalons,
  'replybot': ReplyBotOnboarding,
};




export default function DynamicAppRenderer() {
  const { routeKey } = useParams();
  const Component = routeMap[routeKey];

  if (!Component) {
    return (
      <div className="p-10 text-center text-red-500">
        ⚠️ Unknown app: <strong>{routeKey}</strong>
      </div>
    );
  }

  return <Component />;
}
